var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.loader) ? _c('div', {
    class: _vm.theme.loader
  }, [_c('v-spinner')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.theme.cardHeader,
    on: {
      "click": _vm.handleToggleOpen
    }
  }, [_vm._t("header"), _vm._v(" "), (_vm.collapse) ? _c('v-icon-button', {
    class: _vm.theme.cardCollapseButton
  }, [_vm._v("\n            expand_more\n        ")]) : _vm._e()], 2), _vm._v(" "), (!_vm.collapse) ? _vm._t("default") : _c('v-animation-height', {
    attrs: {
      "height": _vm.contentHeight
    }
  }, [_vm._t("default", null, {
    open: _vm.isOpen
  })], 2)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64fa493d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Card/Card.vue
// module id = 626
// module chunks = 0